import CASL from '@/utils/constants/casl'

export default {
  path: 'pembelian-charger',
  children: [
    {
      path: '',
      name: 'pembelian-charger.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.FINANCE.PEMBELIAN_CHARGER
      },
      component: () => import('./list/PembelianChargerListPage.vue')
    },
    {
      path: ':uid/:validateUid',
      name: 'pembelian-charger.detail',
      meta: {
        action: 'update',
        subject: CASL.ACCESS.FINANCE.PEMBELIAN_CHARGER
      },
      component: () => import('./form/PembelianChargerFormPage.vue')
    }
  ]
}
